/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a number to convert.`)
};

const es_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un número para convertir.`)
};

const de_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Zahl zum Umrechnen ein.`)
};

const nl_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een getal in om te converteren.`)
};

const fr_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre à convertir.`)
};

const it_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero da convertire.`)
};

const pt_br2_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número para converter.`)
};

const pt_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número para converter.`)
};

const ja_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変換する数値を入力してください。`)
};

const zh_ds_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入一个数字进行换算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_invalid", locale)
	if (locale === "en") return en_ds_invalid(inputs)
	if (locale === "es") return es_ds_invalid(inputs)
	if (locale === "de") return de_ds_invalid(inputs)
	if (locale === "nl") return nl_ds_invalid(inputs)
	if (locale === "fr") return fr_ds_invalid(inputs)
	if (locale === "it") return it_ds_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_ds_invalid(inputs)
	if (locale === "pt") return pt_ds_invalid(inputs)
	if (locale === "ja") return ja_ds_invalid(inputs)
	return zh_ds_invalid(inputs)
};